// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gWOvUjvCq2TeKTosebAb {
  height: fit-content;
  max-width: 1200px;
  max-height: 868px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 2rem;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: thin;
}
.gWOvUjvCq2TeKTosebAb .bOz6fZGiN58mm1YGkycv {
  display: flex;
  justify-content: space-between;
}
.gWOvUjvCq2TeKTosebAb .w7nI1uL3hH019sr0o6GN {
  display: flex;
  justify-content: center;
  padding: 0.5rem 4rem;
  gap: 1rem;
}
.gWOvUjvCq2TeKTosebAb .ETrAgdmBN_3luU8DiTSt {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.gWOvUjvCq2TeKTosebAb .PY79Hanmu3RekSrj12Rg {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/componentes/ModalCompartilhar/ModalCompartilhar.module.scss"],"names":[],"mappings":"AAAA;EAEI,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;AAAJ;AAEI;EACI,aAAA;EACA,8BAAA;AAAR;AAGI;EACI,aAAA;EACA,uBAAA;EACA,oBAAA;EACA,SAAA;AADR;AAGI;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AADR;AAGI;EACI,aAAA;EACA,yBAAA;EACA,SAAA;AADR","sourcesContent":[".modal {\r\n    //width: 1200px;\r\n    height: fit-content;\r\n    max-width: 1200px;\r\n    max-height: 868px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 24px;\r\n    padding: 2rem;\r\n    overflow-y: scroll;\r\n    overflow-x: hidden;\r\n    scrollbar-width: thin;\r\n\r\n    .header {\r\n        display: flex;\r\n        justify-content: space-between;\r\n    }\r\n\r\n    .botoesCompartilhar {\r\n        display: flex;\r\n        justify-content: center;\r\n        padding: 0.5rem 4rem;\r\n        gap: 1rem;\r\n    }\r\n    .container {\r\n        width: 100%;\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 2rem;\r\n    }\r\n    .botoesAcao {\r\n        display: flex;\r\n        justify-content: flex-end;\r\n        gap: 1rem;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var modal = `gWOvUjvCq2TeKTosebAb`;
export var header = `bOz6fZGiN58mm1YGkycv`;
export var botoesCompartilhar = `w7nI1uL3hH019sr0o6GN`;
export var container = `ETrAgdmBN_3luU8DiTSt`;
export var botoesAcao = `PY79Hanmu3RekSrj12Rg`;
export default ___CSS_LOADER_EXPORT___;
